import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

import { i18n } from '@/shared/i18n';

/**
 * Wrap the app tree with the shared, singleton i18n instance. Kept as a tiny
 * component so tests and Storybook can compose it next to other providers.
 */
export function I18nProvider({ children }: { children: ReactNode }) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
